import React from 'react';

export const EditIcon = () => {
  return <div data-testid="edit-icon-id" className="vbz-icon-corporates-club-edit-icon" />;
};
